// extracted by mini-css-extract-plugin
module.exports = {"container":"_dU","minus":"_dV","plus":"_dW","header":"_dX","question":"_dY","answer":"_dZ"};